<template>
  <b-modal id="sharebyemail" title="Share by email" size="md" ok-only ok-title="Close" @hide="doSometing">
    <div v-if="!this.isTrial">
      <p>The current search will be sent by email to the following recipient.</p>
      <div class="mt-2">
        <b-form-input v-model="recipientAddress" :state="validateEmail()" placeholder="Enter email address of recipient"></b-form-input>
        <b-form-checkbox v-model="sendCopyToSelf" class="mt-2">
          send copy to myself
        </b-form-checkbox>
      </div>
      <div class="mt-3">
        <b-alert v-if="note=='sent'" variant="success" show>Search has been sent</b-alert>
        <b-alert v-if="note=='error'" variant="danger" show>Please enter a correct email address</b-alert>
      </div>
      <b-button variant="dark" size="md" v-on:click.prevent="shareByEmail()" class="mt-2">Send</b-button>
    </div>
    <div v-else>
      <p>Share by email is not available in the <b>TRIAL</b> version. Want to <a href="https://sci-fund.ai/plans-and-prices" target="_blank">upgrade your account</a>?</p>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: 'ShareByEmail',
  data() {
    return {
      note: '',
      recipientAddress: '',
      sendCopyToSelf: false
    }
  },
  computed: {
    downloadurl () {
      if (this.$store.state.response && this.$store.state.response.base_urls && this.$store.state.response.base_urls && this.$store.state.response.base_urls.search_with_current_state &&
      this.$store.state.response.context &&  this.$store.state.response.context.originalSearchTerms) {
        return this.$store.state.response.base_urls.search_with_current_state.sem_url + "&q=" + encodeURI(this.$store.state.response.context.originalSearchTerms)
      }
      return null;
    },
    isTrial() {
      if (this.$store.state ) {
        return this.$store.state.isTrial;
      }
      return false;
    }
  },
  methods: {
    shareByEmail () {
      if(this.downloadurl && this.validateEmail() ) {
        this.note='sent';
        this.$store.dispatch('shareByEmail', { 'searchURL': this.downloadurl, 'recipientAddress': this.recipientAddress, 'sendCopyToSelf': this.sendCopyToSelf });
      } else {
        this.note='error';
      }
    },
    validateEmail() {
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(this.recipientAddress).toLowerCase());
    },
    doSometing () {
      this.note='';
      this.recipientAddress='';
      this.sendCopyToSelf=false;
    }
  }

}
</script>
<style scoped>
</style>
